import { useT } from '../i18n';

const MODE_IDS = [
  { id: 'brainstormer', icon: '🧠' },
  { id: 'study',        icon: '📚' },
  { id: 'planner',      icon: '🎯' },
  { id: 'creative',     icon: '💡' },
];

export const ModeSelector = ({ currentMode, onModeChange }) => {
  const t = useT();
  return (
    <div className="grid grid-cols-2 gap-1.5">
      {MODE_IDS.map(({ id, icon }) => {
        const active = currentMode === id;
        return (
          <button
            key={id}
            onClick={() => onModeChange(id)}
            className="flex items-center justify-center gap-1.5 px-3 py-1.5 rounded-[10px] text-[12px] font-medium transition-all duration-200 border-2"
            style={active
              ? { background: 'color-mix(in srgb, var(--accent-2) 20%, transparent)', borderColor: 'var(--accent-2)', color: 'var(--text-primary)', boxShadow: '0 2px 6px color-mix(in srgb, var(--accent-2) 20%, transparent)' }
              : { borderColor: 'var(--border)', color: 'var(--text-muted)', background: 'transparent' }
            }
          >
            <span>{icon}</span>
            <span>{t(`modes.${id}`)}</span>
          </button>
        );
      })}
    </div>
  );
};
